import React from 'react';
import './Footer.css'
const Footer = props => {
    return (
        <div className='Footer' >
            <div className='footer-main' >
            <div className='footer-left-line' ></div>
            <p className='footer-text' >
                Design and built by Ujjaval Sinha
            </p>
            <div className='footer-right-line' ></div>
            </div>
        </div>
    )
}

export default Footer